/***********************************
Menu Module
************************************/

Quad.InvestorEventSearch = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    /* Get the grey filter's height to align with the ever-changing height of the search results */

    function filterMatchHeight() {
      var resultHeight = $( '#filter-match' ).height();
      $( '#filter' ).css( 'min-height', resultHeight );
    }
    $( document ).ready( function() {
      filterMatchHeight();
    });
    $( window ).resize( function() {
      filterMatchHeight();
    });


    /*
    *
    * NOTES: In the WP API, multi post type search is fed through array, categories are simple comma-separated strings
    *
    * Global search settings, offset pagination, etc.
    *
    */


    var topics = [], allTopics, medias = [], allMedia;

    $( 'input[name="type[]"]' ).each( function( i ) {
      topics[ i ] = $( this ).val();
    });
    allTopics = topics.join( ', ' );

    $( 'input[name="year[]"]' ).each( function( i ) {
      medias[ i ] = $( this ).val();
    });
    //allMedia = JSON.stringify( medias );
    allMedia = medias.join( ', ' );

    function getAllMedia() {
      var medias = [], allMedia;
      $( 'input[name="year[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });
      return JSON.stringify( allMedia );
    }

    var offset = 0;

    //investorEventSearch( 0, 'all', null, null, false );

    /* Load More business logic */

    
    $( '.pagination button' ).click( function() {

      var year = [];
      $( 'input[name="year[]"]:checkbox:checked' ).each( function( i ) {
        year[ i ] = $( this ).val();
      });
      JSON.stringify( year );
      var years = [];
      $( 'input[name="year[]"]' ).each( function( i ) {
        years[ i ] = $( this ).val();
      });
      JSON.stringify( years );

      year.length === 0 ? year = years : year;

      $( this ).addClass( 'loading' );

      // TODO: Offset keeps racking up, but it should be reset with fresh queries

      offset += 12;

      //offset,type,topic,query,isLoadMore

      investorEventSearch( offset, year, null, null, true );

    });

    /* Checkboxes, part 1: Parsing query strings if applicable */

    if ( typeof type_filter === 'object' && type_filter.length !== null ) {
      var typeLength = type_filter.length;
      for ( var i = 0; i < typeLength; i++ ) {
        $( '.resource-filter[value="'+ type_filter[ i ] +'"]' ).parent().addClass( 'checked' );
        $( '.resource-filter[value="'+ type_filter[ i ] +'"]' ).prop( 'checked', true );
      }
    }
    if ( typeof cat_filter === 'object' && cat_filter.length !== null ) {
      var catLength = cat_filter.length;
      for ( var i = 0; i < catLength; i++ ) {
        $( '.resource-filter[value="'+ cat_filter[ i ] +'"]' ).parent().addClass( 'checked' );
        $( '.resource-filter[value="'+ cat_filter[ i ] +'"]' ).prop( 'checked', true );
      }
    }

    /* Checkbox business logic */

    var toggled = false;

    $( '.icheckbox' ).on( 'ifToggled', function( event ){

      if( $(this).hasClass('checked') ){

        investorEventSearch( 0, medias, allTopics, null, false );
      
      } else {

        $( '.icheckbox' ).children( '.resource-filter' ).prop( 'checked', false );
        $( '.icheckbox' ).removeClass( 'checked' );
        $( this ).children( '.resource-filter' ).prop( 'checked', true );
        var mediaType = [];
        $( 'input[name="year[]"]:checkbox:checked' ).each( function( i ) {
          mediaType[ i ] = $( this ).val();
        });
        mediaType.join( ', ' );
        var medias = [];
        $( 'input[name="year[]"]' ).each( function( i ) {
          medias[ i ] = $( this ).val();
        });
        medias.join( ', ' );
        mediaType.length === 0 ? mediaType = medias : mediaType;
        mediaType = mediaType.toString();
        offset = 0;
        investorEventSearch( 0, mediaType, null, null, false );
      
      }

    });


    /* Search reset business logic */


    $( '.clear-posts' ).click( function() {

      $( '.icheckbox' ).removeClass( 'checked' );
      $( '.icheckbox .resource-filter' ).prop( 'checked', false );

      offset = 0;

      investorEventSearch( 0, 'all', allTopics, null, false );

    });

    /* SEARCH - The meat and potato function */

    function investorEventSearch( offset, type, topic, query, isLoadMore ) {

      topic = null;
      query = null;

      isLoadMore ? '' : $( '#resource-table-content .resource' ).remove();

      var path = window.location.href.split( '/' );
      path = path[ 0 ]+'//'+path[ 2 ];

      if( type == undefined || type == '2020,2019,2018,2017,2016,older' ){
        
        type = 'all';
      
      }

      $( '#no-results' ).hide();

      $.ajax({

        method: 'POST',
        url: path + '/wp-admin/admin-ajax.php',
        data: {

          offset: offset,
          year: type,
          topic: topic,
          query: query,
          action: 'sort_event_posts'

        },
        success: function( response ) {

          console.log( response );

          if( response.data.posts.length ){

            response.data.posts[0].grand_total > 12 ? $('#load-more').show() : $('#load-more').hide();

          }

          $( '.pagination button' ).removeClass( 'loading' );

          var posts = response.data.posts;

          if ( posts.length > 0 ) {

            for ( var i = 0; i < posts.length; i++ ) {

              var pdf, replay, transcript;

              if( posts[ i ].pdf.length ){
                pdf = '<a class="resource-icon" href="'+posts[ i ].pdf+'" target="_blank">'+
                        '<span class="icon icon-page"></span><small>PDF</small>'
                      '</a>';
              } else {
                pdf = '';
              }
              if( posts[ i ].replay.length ){
                replay = '<a class="resource-icon" href="'+posts[ i ].replay+'" target="_blank">'+
                            '<span class="icon icon-replay"></span><small>Play</small>'
                          '</a>';
              } else {
                replay = '';
              }
              if( posts[ i ].transcript.length ){
                transcript = '<a class="resource-icon" href="'+posts[ i ].transcript+'" target="_blank">'+
                                '<span class="icon icon-transcript"></span><small>Transcript</small>'
                            '</a>';
              } else {
                transcript = '';
              }

              $( '#resource-table-content' ).append(

                '<article class="resource" data-last-post-date="'+ posts[ i ].date_id +'">'+
                  '<div class="col-1">'+
                    '<time>'+ posts[ i ].date +'</time>'+
                  '</div>'+
                  '<div class="col-2">'+
                    '<span>'+ posts[ i ].title +'</span>'+
                  '</div>'+
                  '<div class="col-3">'+
                    pdf +
                    replay +
                    transcript +
                  '</div>'+
                '</article>'

                );

              }

            } else {

              $( '#no-results' ).show();

            }

            filterMatchHeight();

            var grandTotal;

            posts.length > 0 ? grandTotal = posts[ 0 ].grand_total : grandTotal = 0;

            grandTotal <= 12 || grandTotal - posts[ 0 ].offset <= 12 ? $( '#load-more' ).addClass( 'hidden' ) : $( '#load-more' ).removeClass( 'hidden' );

            if ( isLoadMore ) {

              var currentInt = $( '.current-count' ).text();
              currentInt = parseInt( currentInt );
              $( '.current-count' ).text( currentInt += posts.length );

            } else {

              $( '.current-count' ).text( posts.length > 12 ? 12 : posts.length );
              $( '.total' ).text( grandTotal );

            }

          },

          error: function( response ) {
            console.log( 'Error.' );
          }

        });

      }

    }


    // PUBLIC METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    return {

      init: _init

    };

  })();

